<template>
  <div>
    <section class="hero is-light m-2">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            NOTICIAS
          </h1>
        </div>
      </div>
    </section>


    <section class="section is-medium">

    <div class="container">

      <div class="columns mt-01" v-for="(news, i) in chunkedNews">
        <div class="column is-4" v-for="(n, i) in news">
          <img :src="'https://api.plataformasocialmedia.pw'+n.images[0].path+'/'+n.images[0].file_name" :alt="n.title"/>
          <router-link :to="{name:'NoticiasPage',params:{slug:n.slug}}">
            <h3 class="title is-size-4">{{ n.title }}</h3>
          </router-link>

        </div>

      </div>

      <pagination v-if="links!=null" :links="links" :meta="meta" @paginate="init()"></pagination>


    </div>
  </section>



  </div>
</template>

<script>
import axios from 'axios';
import Pagination from '@/components/layouts/partials/pagination'
import VueLodash from 'vue-lodash'

export default {
  name: 'Noticias',
  data () {
    return {
      news:[],
      links:[],
      meta:{'current_page':1},
    }
  },
  components: {
    'pagination': Pagination,
  },
  computed: {
   chunkedNews () {
     return _.chunk(this.news,3)
   }
  },
  methods:{
    init(){
      var self = this;
      axios.post(process.env.API_URL_V1+'news?page='+this.meta.current_page+'&api_token='+process.env.API_TOKEN_V1, {type_web:'croc',limit:7})
      .then(function (response) {
        self.news=response.data.data;
        self.links=response.data.links;
        self.meta=response.data.meta;
      })
      .catch(function (error) {
      });
    },
  },
  created :function(){
    this.init();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Noticias.vue